import axios from "../axios/axios";

import * as MECHANIC_END_POINTS from "../constants/endpoints/mechanic";

export const getAllMechanicCollections = async () => {
  return await axios({
    url: MECHANIC_END_POINTS.getAllMechanicCollections,
    method: "GET",
  });
};

export const getMechanicDetails = async () => {
  return await axios({
    url: MECHANIC_END_POINTS.GET_MECHANIC_DETAILS,
    method: "GET",
  });
};

export const getMechanicWeeklyBonus = async () => {
  return await axios({
    url: MECHANIC_END_POINTS.getMechanicWeeklyBonus,
    method: "GET",
  });
};

export function createMechanicBackInStock(skuId) {
  return axios({
    url: MECHANIC_END_POINTS.CREATE_MECHANIC_BACK_IN_STOCK.replace(
      ":skuId",
      skuId
    ),
    method: "POST",
  });
}
